import "./Header.css";
import React, { lazy, Suspense, useContext, useEffect, useState } from "react";
import {
  IonButtons,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonItem,
  IonLabel,
  IonText,
  IonCol,
  IonImg,
  IonIcon,
  IonMenuButton,
  IonRouterLink,
} from "@ionic/react";
import { Auth } from "aws-amplify";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import jwt_decode from "jwt-decode";
//import GroupsComponent from "../GroupsComponent";
import { getUserAttributes } from "../../services/Helpers";
import { exit } from "ionicons/icons";
import { useHistory } from "react-router";
const LazyLoadGroupsComponent = lazy(() => import("../GroupsComponent"));

const getDecodedAccessToken = (token: string) => {
  try {
    return jwt_decode(token);
  } catch (Error) {
    return null;
  }
};

const Header: React.FC = () => {
  const history: any = useHistory();
  const { providerState } = useContext(ProviderContext);
  const { userState, setUserState } = useContext(ApplicationContext);
  const [userAttributes, setUserAttributes] = React.useState<any | undefined>(
    {}
  );
  const [userFullName, setUserName] = useState("");

  const item = { src: "assets/img/icon.png" };

  const logout = () => {
    setUserState({ authenticatedUser: undefined });
    Auth.signOut();
    history.go(0);
  };

  useEffect(() => {
    let user = userState.authenticatedUser;

    setUserName(
      user.attributes["given_name"] + " " + user.attributes["family_name"]
    );
    let attr = getUserAttributes(user.signInUserSession["idToken"].jwtToken);
    setUserAttributes(attr);
  }, []);

  function toggleMenu() {
    const splitPane = document.querySelector("ion-split-pane");
    const windowWidth = window.innerWidth;
    const splitPaneShownAt = 992;
    const when = `(min-width: ${splitPaneShownAt}px)`;
    if (windowWidth >= splitPaneShownAt) {
      // split pane view is visible
      const open = splitPane.when === when;
      splitPane.when = open ? false : when;
    } else {
      // split pane view is not visible
      // toggle menu open
      const menu = splitPane.querySelector("ion-menu");
      return menu.open();
    }
  }

  function editProfile(profile) {
    history.push("/updateprofile", { user: profile.attributes });
  }

  return (
    <IonHeader className="header">
      <IonToolbar>
        <IonCol slot="start">
          <IonImg src={item.src} className="logo"></IonImg>
          <IonButtons>
            <IonMenuButton />
          </IonButtons>
        </IonCol>

        <IonCol slot="end">
          <IonItem>
            <IonLabel>Welcome {userFullName} </IonLabel>
            <IonRouterLink onClick={() => logout()} className="link">
              &nbsp;Signout <IonIcon icon={exit} className="link" />
            </IonRouterLink>
          </IonItem>
          <IonItem>
            <IonLabel>Logged in as {userAttributes?.roles}</IonLabel>
            <IonRouterLink
              onClick={(e) => {
                editProfile(userState.authenticatedUser);
              }}
            >
              <IonText className="link">&nbsp;Edit</IonText>
            </IonRouterLink>
          </IonItem>
        </IonCol>
        <IonCol slot="start">
          <IonTitle>
            <h3>Medline Health</h3>
          </IonTitle>
          <Suspense fallback={<p>loading...</p>}>
            <LazyLoadGroupsComponent />
          </Suspense>
        </IonCol>
      </IonToolbar>
    </IonHeader>
  );
};

export default Header;
